import { Icon, CustomTable, ConfirmationPopup, SuccessModal, Loader } from '@ohif/ui';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '@custom/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { getCaseCredits } from '@custom/rtk-apis/Setting/creditForCaseToCase/getCaseCredits';
import { useTheme } from '../../../ui/src/contextProviders';
import { _routes } from '@custom/Utils/constants/routes';
import { servicesManager } from "../../../app/src/App";
import { deleteCaseCredit } from '@custom/rtk-apis/Setting/creditForCaseToCase/deleteCaseCredit';
import { clearGetCaseCreditsState } from '@custom/store/slices/Setting/creditForCaseToCase/getCaseCreditsSlice';
import { clearDeleteCaseCreditState } from '@custom/store/slices/Setting/creditForCaseToCase/deleteCaseCreditSlice';
import { _roleType } from '@custom/Utils/constants/appConstants';

const CreditsForCaseToCase = () => {
  const isDarkMode = useTheme();
  const dispatch = useDispatch<AppDispatch>();
  const { uiNotificationService } = servicesManager?.services;

  // Fetch machine list from Redux state
  const getCaseCreditResponse = useSelector((state: RootState) => state?.getCaseCreditResponse);
  const deleteCaseCreditResponse = useSelector((state: RootState) => state?.deleteCaseCreditResponse);

  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([]);
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [columns, setColumns] = useState([
    { key: 'modality', title: 'Modality' },
    { key: 'credit', title: 'Credit' },
  ]);

  useEffect(() => {
    dispatch(getCaseCredits());
  }, [dispatch, searchQuery, pgNumber, pgLimit]);

  useEffect(() => {
    if (getCaseCreditResponse?.result && getCaseCreditResponse?.status === 'SUCCESS') {
      const updatedTableData = getCaseCreditResponse.result.map(item => ({
        ...item,
        value: item.credit * (getCaseCreditResponse?.fullDoc?.creditValue || 1)
      }));
      setTableData(updatedTableData);
      setTimeout(() => {
        dispatch(clearGetCaseCreditsState());
      }, 500);
    }
  }, [getCaseCreditResponse?.result]);

  useEffect(() => {
    if (deleteCaseCreditResponse.status === 'SUCCESS' && !deleteCaseCreditResponse.loading) {
      setIsSuccessModal(true);
      setTimeout(() => {
        dispatch(getCaseCredits()); // fetch updated list
        dispatch(clearDeleteCaseCreditState()); // clear state AFTER fetch
      }, 500);
    } else if (deleteCaseCreditResponse.status === 'FAILED' && !deleteCaseCreditResponse.loading) {
      setIsSuccessModal(false);
      uiNotificationService.show({
        title: 'Error',
        message: deleteCaseCreditResponse?.error || 'Something went wrong...',
        type: 'error',
      });
      dispatch(clearDeleteCaseCreditState()); // clear state AFTER fetch
    }
  }, [deleteCaseCreditResponse.status, deleteCaseCreditResponse.loading]);

  const actions = [
    {
      label: 'Edit',
      iconName: 'edit',
      onClick: (item) => {
        navigate(_routes.settings.addEditCreditForCaseToCase, {
          state: {
            CreditsForCaseToCase: item,
          },
        });
      },
    },
    {
      label: 'Delete',
      iconName: 'delete',
      onClick: (item) => {
        setSelectedRow(item);
        setIsPopupOpen(true);
      },
    },
  ];

  const handleConfirm = () => {
    if (selectedRow) {
      dispatch(deleteCaseCredit({ id: selectedRow._id }))
    }
    setIsPopupOpen(false);
  };

  const handleCancel = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const role = sessionStorage.getItem('role') || localStorage.getItem('role');
    if (role === _roleType.superAdmin) {
      setIsSuperAdmin(true);
      setColumns([
        { key: 'modality', title: 'Modality' },
        { key: 'credit', title: 'Credit' },
        { key: 'actions', title: 'Action' },
      ])
    }
  },[])

  return (
    <>
      <div className="tableWrap">
        <div className="tableWrap__head">
        </div>
        <div className="tableContainer">
          {getCaseCreditResponse?.loading || deleteCaseCreditResponse?.loading ?
            <Loader isLoaderOpen={true} /> :
            <CustomTable
              columns={columns}
              data={tableData}
              actions={isSuperAdmin ? actions : []}
              searchQuery={searchQuery}
              from="creditsforcasetocase"
              userDetails={{}}
              setClickedItem={() => {}}
              clickedItem={null}
              approvedHospitals={[]}
            />}
        </div>
        <ConfirmationPopup
          title={""}
          isOpen={isPopupOpen}
          message={`Are you sure you want to delete credits for ${selectedRow?.modality} modality?`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
        <SuccessModal
          isSuccessModalOpen={isSuccessModalOpen}
          title={`Machine delete successfully.`}
          handleCloseModal={() => setIsSuccessModal(false)}
        />
      </div>
    </>
  );
};

export default CreditsForCaseToCase;
